import { Navigate } from "react-router-dom";
import { useContext, useState } from "react";
import globalContext from "../context/context";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const ProtectedRoute = ({ children }) => {
    const { contextData } = useContext(globalContext);
    const [showDialog, setShowDialog] = useState(true);

    if (contextData.formValues?.origin_airport && contextData.formValues?.destination_airport) {
        return children;
    }
    
    return (
        <>
            <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
                <DialogTitle>Keresés szükséges</DialogTitle>
                <DialogContent>
                    <Typography>Az oldal eléréséhez először válassza ki a reptér(ek)et, dátumot és utasok számát a főoldalon.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowDialog(false)} variant="contained">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Navigate to="/" replace />
        </>
    );
};

export default ProtectedRoute;
